import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  callAPI,
  getLocalValue,
  IRoleMain,
  LoacalVariables,
  Method,
  TransactionPages
} from "../../../commonFunctions/CommonFunctions";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import { openPopUp } from "../../../Components/Dialog/OpenNewModal";
import { IMetaData } from "../../../Components/Dialog/WSCommonDialog";
import { IRows } from "../../../Components/Filter/WSFilterComponent";
import { HeaderList } from "../../../Components/Header/HeaderList";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import clientconfig from "../../../Config/clientConfig.json";
import { resetDataComponent } from "../../../StateManagement/actions";
import { UpdateStatus } from ".././UpdateStatus";
import { getPermissions } from "../../../commonFunctions/PermissionManger";
import PermissionDenied from "../../../commonFunctions/PermissionDenied";
import ConfirmDialog from ".././Compo/ConfirmationModal";
import ConfirmationPopup from "../../../Components/Confirmation/Confirmation";

export type OrderItem = {
  productId: string;
  productName: string;
  serviceName: string;
  quantity: number;
  itemTag: string;
};

export type GroupedProduct = {
  productId: string;
  productName: string;
  services: string[];
  quantity: number;
  itemTag: string;
};

export const PickupOrderList: React.FC<any> = () => {
  const { edit, add, view, changestatus, exports } = getPermissions(
    TransactionPages.OrdersList,
    IRoleMain.Transactions
  );
  const { showMessage } = useSnackbar();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [orderId, setOrderID] = useState<any>(null);
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [totalCount, setTotalCount] = useState<any>();

  const columns: IColumns[] = [
    // {
    //   header: "Name",
    //   fieldName: "customer.fullName",
    //   type: "default",
    //   sortable: true
    // },
    // {
    //   header: "Phone",
    //   fieldName: "customer.phoneNumber",
    //   type: "default"
    // },
    {
      header: "Requested Date",
      fieldName: "requestedDate",
      type: "date",
      sortable: true
    },
    {
      header: "Scheduled PickupTime",
      fieldName: "scheduledPickupTime",
      type: "default",
      sortable: true
    },

    {
      header: "Address",
      fieldName: "address",
      type: "default",
      sortable: true
    },
    { header: "Status", fieldName: "status", type: "status" },

    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: [
        edit ? "Edit" : undefined,
        "Delete",
        changestatus ? "Change Status" : undefined,
        "Generate Bill"
      ],
      fieldCompare: {
        fieldName: "orderStatus",
        ValueCheck: { value: "Paid", actionCheck: "Change Status,Edit" }
      },
      hideAction: {
        actionName: [
          {
            fieldName: "orderStatus",
            values: ["Completed"],
            hideAction: ["Edit"]
          },
          {
            fieldName: "orderStatus",
            values: ["Paid"],
            hideAction: ["Change Status,Edit"]
          }
        ]
      },
      actionCallback: (action, row) => handleAction(action, row)
    }
  ];

  const handleClick = () => {
    navigate(`/pickup-order`);
  };

  const source = {
    url: "pickup/search",
    page: 1,
    pageSize: 10,
    filter: [{
          "field": "FranchiseId",
          "operator": "eq",
          "value": getLocalValue(LoacalVariables.FranchiseId)
        }],
    sort: []
  };

  const handleStatus = async (data: any) => {
    try {
      // setLoading(true);
      const response: any = await saveData(data);
      setOrderID(null);

      if (response && response?.message) {
        dispatch(resetDataComponent("pickupGrid"));
        showMessage(
          response.message,
          response.success === true ? "success" : "error"
        );
      }
    } catch (e: any) {
      showMessage(e.error);
    } finally {
      setOrderID(null);
      // setLoading(false);
    }
  };
  const saveData = async (data: any) => {
    const request: any = {
      newStatus: data?.newStatus,
      updatedBy: "Test"
    };

    const response: any = await callAPI(
      `pickup/${orderId}/status`,
      Method.PUT,
      request
    );
    return response;
  };
  const handleCloseDialog = (data?: any) => {
    setOrderID(null);
  };
  useEffect(() => {
    if (orderId) {
      openPopUp(metadataStatus, handleStatus, "40rem", handleCloseDialog);
    }
  }, [orderId]);

  const metadataStatus: IMetaData = {
    title: "Update Status",
    hideActions: false,
    content: (props: any, row: any) => <UpdateStatus {...props} />,
    actions: [
      {
        label: "Cancel",
        // onClick: handleCloseDialog,
        className: "ws-cancel",
        type: "button"
      },
      {
        label: "Submit",
        onClick: handleStatus,
        type: "submit",
        autoFocus: true
      }
    ],
    isDragable: true
  };
  const handleAction = async (action: string, row: any) => {
    if (action === "Edit") {
      navigate(`/pickup-order/${row?.id}`);
    } else if (action === "Delete") {
      setSelectedId(row?.id);
      setPopupOpen(true);
    } else if (action === "Change Status") {
      setOrderID(row?.id);
    }
  };

  const handleDelete = (response: any) => {
    dispatch(resetDataComponent("pickupGrid"));
    showMessage("Pickup order removed successfully!", "success");
  };

  return (
    <>
      <HeaderList
        title="Pickup Orders"
        type="card"
        info={`${totalCount || 0} Total Records`}
      />
      {view ? (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <WSDataGrid
              id="pickupGrid"
              title="Pickup Orders"
              columns={columns}
              addButton={{ label: "New", color: "secondary" }}
              onAddButtonClick={handleClick}
              headerType="HaderTopCornered"
              source={source}
              exportCsv={exports}
            />
          </Grid>
        </Grid>
      ) : (
        <PermissionDenied />
      )}

      {selectedId !== null && (
        <ConfirmationPopup
          apiUrl={"Brand/delete"}
          id={selectedId}
          confirmMessage="Are you sure you want to delete this pickup order?"
          open={isPopupOpen}
          onClose={() => setPopupOpen(false)}
          onConfirm={handleDelete}
        />
      )}
    </>
  );
};